import classNames from 'classnames';
import {FC} from 'react';
import styles from './MeinDot.module.css';

interface IProps {
    isWhite?: boolean;
    isLight?: boolean;
    classNameDot?: string;
}

export const MeinDot: FC<IProps> = ({isLight, isWhite, classNameDot}) => {
    return (
        <span
            className={classNames(styles.dot, classNameDot, {
                [styles.white]: isWhite,
                [styles.light]: isLight,
            })}
        >
            •
        </span>
    );
};
